import React from 'react';

export interface ProviderContext {
  doRating: (order_id: number, default_rating:number) => Promise<number>
}

// @ts-ignore
export default React.createContext<ProviderContext>();